import { fetchAuthSession } from "@aws-amplify/auth";

export async function authenticatedFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
): Promise<Response> {
  const headers = new Headers(init.headers);

  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token && !headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }
  } catch {
    // Local development may rely on the same-origin Django session instead.
  }

  return fetch(input, {
    ...init,
    credentials: init.credentials ?? "same-origin",
    headers,
  });
}
